module.exports = __webpack_public_path__ + "img/CS-Lite-Vol-Info.8a68e02e.jpg";